<template>
  <tr>
    <td>
      <b-form-input v-model="objTest.descripcion" type="text"></b-form-input>
    </td>
    <td>
      <b-form-input v-model="objTest.leyInicial" type="number"></b-form-input>
    </td>
    <td>
      <b-form-input v-model="objTest.pptoFinal" type="number"></b-form-input>
    </td>
    <td>
      <b-form-input v-model="objTest.devengado" type="number"></b-form-input>
    </td>
    <td>
      <b-form-input v-model="objTest.observaciones" type="text"></b-form-input>
    </td>
    <td><i @click="removeItem(objTest)" class="bx bxs-trash"></i></td>
  </tr>
</template>
<script>
export default {
  props: ["removeItem", "objTest"],
};
</script>
<style scoped>
.controller-forms {
  font-size: 0.8rem !important;
  width: 100% !important;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}

.bxs-trash {
  font-size: 1.5rem;
  color: #25a2b7;
  cursor: pointer;
}
</style>
